import { type Common } from '../common.js';

interface GetPayorDisplayNameMappingQuery {
  previsitFormSetId: string;
}
export class API {
  common: Common;
  baseEndpoint = '/patient-previsit/payors';

  constructor(common: Common) {
    this.common = common;
  }

  async getPayorDisplayNameMapping(
    query: GetPayorDisplayNameMappingQuery
  ): Promise<Record<string, string>> {
    const url = this.common.constructPath(`${this.baseEndpoint}`, query);
    return await this.common.getJSON(url);
  }
}
